import { initCoupaDetection } from './isRunningInCoupa';

initCoupaDetection();
